export const enlacesRedes = [
  {
    name: "Facebook",
    enlace: "https://www.facebook.com/SaludJujuy",
    icon: "facebook",
    color: "#3b5998",
  },
  {
    name: "Instagram",
    enlace: "https://www.instagram.com/saludjujuy/?hl=es",
    icon: "instagram",
    color: "#125688",
  },
  {
    name: "Twitter",
    enlace: "https://twitter.com/SaludJujuy/",
    icon: "twitter",
    color: "#55acee",
  },
  {
    name: "YouTube",
    enlace: "https://www.youtube.com/@SaludDeJujuy",
    icon: "youtube",
    color: "#bb0000",
  },
];
